var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"gap-3",attrs:{"column":""}},[(_vm.title)?_c('div',{staticClass:"text-body-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._l((_vm.links),function(link){return _c('v-btn',{key:link.title,attrs:{"href":link.href,"color":"primary"}},[_vm._v(" "+_vm._s(link.title)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }